import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BrandFeatures from "./components/BrandFeatures";
import ProductCategories from "./components/ProductCategories";
import FeaturedProducts from "./components/FeaturedProducts";
import LookbookSection from "./components/LookbookSection";
import TestimonialsSection from "./components/TestimonialsSection";
import StoreInfoSection from "./components/StoreInfoSection";
import LineCtaSection from "./components/LineCtaSection";
import PageSEO from "@/components/base/PageSEO";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "台中設計師女裝Outlet｜30年品牌優雅熟齡穿搭",
  "description": "台中設計師女裝Outlet，精選台灣30年品牌服飾，提供熟齡女性修身洋裝、套裝、外套等高質感女裝，Outlet優惠價格，歡迎預約試穿。",
  "url": "https://www.example.com/",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "首頁", "item": "https://www.example.com/" }]
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <PageSEO
        title="台中設計師女裝Outlet｜30年品牌優雅熟齡穿搭"
        description="台中設計師女裝Outlet，精選台灣30年品牌服飾，提供熟齡女性修身洋裝、套裝、外套等高質感女裝，Outlet優惠價格，歡迎預約試穿。"
        keywords="台中女裝,設計師品牌Outlet,熟齡穿搭,修身洋裝,台中服飾"
        canonical="https://www.example.com/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <BrandFeatures />
        <ProductCategories />
        <FeaturedProducts />
        <LookbookSection />
        <TestimonialsSection />
        <StoreInfoSection />
        <LineCtaSection />
      </main>
      <Footer />
    </div>
  );
}
